import {
    CLEAR_ALL,
    LOAD_SERVER_LIST,
    LOAD_SERVER_LIST_SUCCESS,
    LOAD_SERVER_LIST_ERROR,
    CLEAR_SERVER_LIST,
} from '../constants/ActionTypes';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case LOAD_SERVER_LIST:
            return {
                ...state,
                [action.payload.list]: {
                    loading: true,
                    error: false,
                    data: [],
                },
            };
        case LOAD_SERVER_LIST_SUCCESS:
            return {
                ...state,
                [action.payload.list]: {
                    loading: false,
                    error: false,
                    data: action.payload.data,
                },
            };
        case LOAD_SERVER_LIST_ERROR:
            return {
                ...state,
                [action.payload.list]: {
                    loading: false,
                    error: true,
                    data: [],
                },
            };
        case CLEAR_SERVER_LIST:
            return {
                ...state,
                [action.payload.list]: {
                    loading: false,
                    error: false,
                    data: [],
                },
            };
        case CLEAR_ALL:
            return initialState;
        default:
            return state;
    }
}
